import {
  HydrationBoundary,
  QueryClient,
  QueryClientProvider
} from '@tanstack/react-query'
import { useState } from 'react'

import { MapViewerProvider as DeprecatedProvider } from 'map-viewer'
import { Cookies } from 'ms-cookies'
import { TagManager } from 'tag-manager'
import { AppErrorDialog, ErrorBoundary, UIProvider } from 'ui-components'
import { AuthProvider } from 'user-auth'

function Fallback() {
  return <AppErrorDialog open />
}

export function Provider(props) {
  const { ssr, dehydratedState, authState, children } = props

  const [queryClient] = useState(() => {
    const queryClient = new QueryClient({
      defaultOptions: {
        queries: {
          // With SSR, we usually want to set some default staleTime
          // above 0 to avoid refetching immediately on the client
          staleTime: 15 * 1000
        }
      }
    })

    return queryClient
  })

  return (
    <>
      <TagManager
        gtmId={process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID as string}
        gaId={process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID as string}
      />

      <QueryClientProvider client={queryClient}>
        <HydrationBoundary state={dehydratedState}>
          <AuthProvider
            state={authState}
            ssr={ssr}
          >
            <UIProvider>
              <ErrorBoundary
                fallback={Fallback}
                disableLog={false}
              >
                <DeprecatedProvider>{children}</DeprecatedProvider>
                <Cookies />
              </ErrorBoundary>
            </UIProvider>
          </AuthProvider>
        </HydrationBoundary>
      </QueryClientProvider>
    </>
  )
}
